/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegalAgreementContentResponse
 */
export interface LegalAgreementContentResponse {
    /**
     * HTML content of the legal agreement.
     * @type {string}
     * @memberof LegalAgreementContentResponse
     */
    content: string;
}

/**
 * Check if a given object implements the LegalAgreementContentResponse interface.
 */
export function instanceOfLegalAgreementContentResponse(value: object): value is LegalAgreementContentResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function LegalAgreementContentResponseFromJSON(json: any): LegalAgreementContentResponse {
    return LegalAgreementContentResponseFromJSONTyped(json, false);
}

export function LegalAgreementContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalAgreementContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
    };
}

export function LegalAgreementContentResponseToJSON(value?: LegalAgreementContentResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'content': value['content'],
    };
}

